<template>
  <div class="dev-overlay-view">
    <div class="container">
      <component :is="currentView" />
    </div>
  </div>
</template>

<script lang="ts">
import { Component, computed, defineComponent } from 'vue';

import useDevOverlayStore from '@/stores/devOverlay';

import ConfigsView from './views/ConfigsView.vue';
import FeatureFlagsView from './views/FeatureFlagsView.vue';

export default defineComponent({
  setup() {
    const store = useDevOverlayStore();

    type ToolGroupKey = typeof store.toolsGroups[number];

    const viewsMapping: Record<ToolGroupKey, Component> = {
      configs: ConfigsView,
      featureFlags: FeatureFlagsView,
    };

    const currentView = computed(() => {
      const toolGroup = store.toolsGroups.includes(store.currentToolsGroup)
        ? store.currentToolsGroup
        : store.toolsGroups[0];

      return viewsMapping[toolGroup];
    });

    return { currentView };
  },
});
</script>

<style scoped lang="scss">
.dev-overlay-view {
  padding: 1rem 2rem;

  .container {
    width: 100%;
    max-width: 700px;
  }
}
</style>
